// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1679":"6fe7d53b","4464":"012a09c0","4758":"d5465e27"}[chunkId] + ".chunk.css";
};